import { toString } from 'lodash';
import getMonolithHost from '../../../utils/getMonolithHost';

const apiHost = getMonolithHost();

export default function fetchBootstrap({ fetchFunc, url, bookingId }) {
    return fetchFunc(
        `${apiHost}/api/rest/scheduling/v1/requests/${bookingId}/bootstrap`
    )
        .then(resp => resp.json())
        .then(data => {
            data.logGaPageview = true;
            data.bookingId = bookingId;
            data.socialUserDetails = data.socialUserDetails || null;
            data.whiteLabelName = data.whiteLabelName || '';
            data.whiteLabelUrl = data.whiteLabelUrl || '';
            data.locationId = toString(data.locationId);
            data.procedureId = toString(data.procedureId);
            data.professionalId = toString(data.professionalId);
            return data;
        });
}
